<div
  id="werbebanner"
  class="contentblock"
  [innerHTML]="werbebannerContent | img | async"
  [class.mobil]="environment.type == 'mobil'"
  [class.web]="environment.type == 'web'"
  tabindex="0"
  (click)="werbebannerService.ankuendigungsPopup()"
  (keydown.enter)="werbebannerService.ankuendigungsPopup()"
>
</div>
